<template>
  <!-- Besoins exprimés -->
  <div class="h3">
    Vous avez déclaré rechercher les niveaux de couverture suivants :
  </div>

  <ul>
    <li>Hospitalisation : {{ user.labelHospitalisation }}</li>
    <li>Dentaire : {{ user.labelDentaire }}</li>
    <li>Optique : {{ user.labelOptique }}</li>
    <li>Honoraires médicaux et Pharmacie : {{ user.labelMedecine }}</li>
    <li>Prévention : {{ user.labelPrevention }}</li>
  </ul>

  <!-- Cas des retraités entre 55 et 80 ans -->
  <p v-if="user.displayObstetriqueOuOrthodontie">
    Par ailleurs, vous nous avez précisé {{ user.besoinObstetrique !== '0' ? '' : 'ne pas' }} vouloir une
    couverture obstétrique et {{ user.besoinOrthodontie !== '0' ? '' : 'ne pas' }} vouloir une couverture orthodontie.<br>
  </p>

  <p>
    <b>Compte tenu des éléments déclarés, nous avons préconisé le produit {{ user.proposition ? user.proposition['combinaison_texte'] : '' }}</b>
  </p>

  <p>
    Après avoir pris connaissance des différentes combinaisons de garanties possibles,
    vous avez choisi la formule <b>{{ user.formuleVigeo }}</b> de SwissLife Santé Retraités, qui correspond à vos besoins.
  </p>
</template>

<script>
export default {
  name: "RecapitulatifNeedsVigeo",
  props: {
    user: {
      type:Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
